import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=a5bc5e4a&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5bc5e4a')) {
      api.createRecord('a5bc5e4a', component.options)
    } else {
      api.reload('a5bc5e4a', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=a5bc5e4a&", function () {
      api.rerender('a5bc5e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KfTSb0b8WfxP/JS/comp/ImgFallback2.vue"
export default component.exports